module.exports = __webpack_public_path__ + "static/media/worry-free-4.e8856556.png";